(function() {
  let isDown = false;
  let startX;
  let scrollLeft;
  let activeSlider = null;

  // 1. CRITICAL: Stop the browser from native-dragging images and links
  document.addEventListener('dragstart', (e) => {
    if (e.target.closest('.addon-scroll')) {
      e.preventDefault(); 
    }
  });

  // 2. Mouse Down (Start Drag)
  document.addEventListener('mousedown', (e) => {
    activeSlider = e.target.closest('.addon-scroll');
    if (!activeSlider) return;

    isDown = true;
    activeSlider.classList.add('dragging');

    // Use getBoundingClientRect for perfectly accurate math inside dynamic cart drawers
    startX = e.pageX - activeSlider.getBoundingClientRect().left;
    scrollLeft = activeSlider.scrollLeft;
  });

  // 3. Mouse Leave or Mouse Up (End Drag)
  const stopDragging = () => {
    if (!isDown) return;
    isDown = false;
    if (activeSlider) {
      activeSlider.classList.remove('dragging');
      activeSlider = null;
    }
  };

  document.addEventListener('mouseup', stopDragging);
  document.addEventListener('mouseleave', stopDragging);

  // 4. Mouse Move (Execute Scroll)
  document.addEventListener('mousemove', (e) => {
    if (!isDown || !activeSlider) return;
    e.preventDefault(); // Stop text highlighting

    const x = e.pageX - activeSlider.getBoundingClientRect().left;
    // Multiplied by 1.5 to make the swiping feel a bit faster/smoother
    const walk = (x - startX) * 1.5; 
    activeSlider.scrollLeft = scrollLeft - walk;
  });
})();



/*Add to cart workimg code */
document.addEventListener('click', async function(e){

  const btn = e.target.closest('.addon-atc-btn');
  if(!btn) return;

  const variantId = btn.dataset.variantId;

  try {

    btn.disabled = true;
    btn.textContent = 'Adding...';

    const sectionIds = [];

    document.querySelectorAll('cart-items-component').forEach(item => {
      if(item.dataset.sectionId){
        sectionIds.push(item.dataset.sectionId);
      }
    });

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        sections: sectionIds.join(',')
      })
    });

    const sectionResponse = await fetch(
      window.location.pathname +
      '?sections=' +
      sectionIds.join(',')
    );

    const sectionData = await sectionResponse.json();

    sectionIds.forEach(sectionId => {

      const html = sectionData[sectionId];
      if(!html) return;

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newCartItems = doc.querySelector(
        `cart-items-component[data-section-id="${sectionId}"]`
      );

      const currentCartItems = document.querySelector(
        `cart-items-component[data-section-id="${sectionId}"]`
      );

      if(newCartItems && currentCartItems){
        currentCartItems.innerHTML = newCartItems.innerHTML;
      }
    });

    const cart = await fetch('/cart.js').then(r => r.json());

    document.querySelectorAll('.cart-bubble__text-count').forEach(el => {
      el.textContent = cart.item_count;
    });

    btn.textContent = '✓ Added';

    setTimeout(() => {
      btn.textContent = 'Add To Cart';
      btn.disabled = false;
    }, 1000);

  } catch(error){

    console.error(error);

    btn.textContent = 'Error';

    setTimeout(() => {
      btn.textContent = 'Add To Cart';
      btn.disabled = false;
    }, 1000);
  }
});